import $ from 'jquery';
import React from 'react';
import mapTemplates from './tmplMapper.js';
import * as Tmpl from './FeedItemsDesktop.js';

const NEW_POSTS_DELAY = 10000;

class Feed extends React.Component {
  state = {};

  componentDidMount() {
    const zoneHeight = 300;
    $(document).on('scroll.feed', () => {
      let st = $(window).scrollTop();
      let dh = $(document).height();
      let wh = $(window).height() + zoneHeight;
      if (st >= (dh - wh)) {
        this.props.cmd.fetchOlderPosts();
      }
    });
    this._timeout = setTimeout(this._checkForNewPosts, NEW_POSTS_DELAY);
  }

  componentWillUnmount() {
    $(document).off('scroll.feed');
    clearTimeout(this._timeout);
  }

  _checkForNewPosts = () => {
    this.props.cmd.fetchNewPostsCount();
    this._timeout = setTimeout(this._checkForNewPosts, NEW_POSTS_DELAY);
  };

  _onChange = () => {
    this.setState({});
  };

  render() {
    const children = mapTemplates(Tmpl, {
      cmd: this.props.cmd,
      comments: this.props.comments,
      contextActions: this.props.contextActions,
      embeddedObjects: this.props.embeddedObjects,
      likes: this.props.likes,
      modal: this.props.modal,
      myLikes: this.props.myLikes,
      posts: this.props.posts,
    });
    let newPostsAlert = null;
    if (this.props.newPosts > 0) {
      let message = '';
      if (this.props.newPosts > 20) {
        message = 'There are 20+ new posts.';
      } else if (this.props.newPosts > 1) {
        message = `There are ${this.props.newPosts} new posts.`;
      } else {
        message = 'There is a new post.';
      }
      newPostsAlert = (
        <div className="alert alert-info text-center" style={{marginLeft: 72, fontWeight: 'bold'}}>
          <a onClick={this.props.cmd.fetchNewerPosts}>
            {message}
          </a>
        </div>
      );
    }
    let loading = null;
    if (this.props.fetching) {
      loading = (
        <div className="txt-center loading-gif"></div>
      );
    }
    return (
      <div className="main_post overflow-hidden">
        {newPostsAlert}
        {children}
        {loading}
      </div>
    );
  }
}

export default Feed;
